module.exports = "<section id='canvasChess'>\n\n    <div class='sidebar'>\n    </div>\n    <div id='boardContainer'>\n        <canvas id='canvas'></canvas>\n    </div>\n\n</section>"


//////////////////
// WEBPACK FOOTER
// ./app/views/canvasChess.html
// module id = 40
// module chunks = 0